module.exports = __webpack_public_path__ + "static/customer-workflow-management@2x-9830ac4189486ab89366182ae2c87e5b.png";